import axios from "axios";
export default async function ApiInsertarBusqueda(busqueda,idColeccion, resultado, metodo) {
  let var_ingles = "es";
  if (window.location.href.indexOf("en.") > -1) {
      var_ingles = "en";
  }
  let url = "/app/api/buscadorcore/v1/REGISTRABUSQUEDA/"
  let param = {
    "Id_Coleccion": idColeccion,
    "TextoBusqueda": busqueda.replace(/['°|@_=¿?~¡!:/<>()&%#*;+-.,?^${}[(\)]|[\]\\]/g, " "),
    "Palabra_relacionada": "",
    "Lang": var_ingles,
    "Resultado": resultado,
    "Latitud": 0,
    "Longitud": 0,
    "UserAgent": "",
    "Lenguaje": var_ingles,
    "Plataforma": "",
    "IPUser": "",
    "Ciudad": "",
    "Metodo": metodo
}
  const header = {
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
      },
    };
  await axios.post(url, param, header);
}